export const careerCategories = {
  'technology': {
    name: '技术领域',
    types: ['INTJ', 'INTP', 'ISTP', 'ENTP'],
    description: '适合逻辑思维强，喜欢解决问题的类型',
    careers: [
      '软件工程师', '系统架构师', '数据科学家', '人工智能研究员',
      '网络安全专家', '数据库管理员', '技术总监', 'DevOps工程师'
    ]
  },
  // ... 其他职业类别
} 